/**
 * SpatialChat Component
 */

import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SpatialChat = ({ messages = [], listeners = [] }) => {
  const [visibleMessages, setVisibleMessages] = useState([]);

  useEffect(() => {
    if (messages.length > 0) {
      const latestMsg = messages[messages.length - 1];
      // Ensure message has a unique ID
      if (!latestMsg?.id) return;
      
      const listener = listeners.find(l => l.id === latestMsg.listenerId);
      if (listener) {
        const msgWithPosition = { 
          ...latestMsg, 
          uniqueKey: `${latestMsg.id}-${Date.now()}`, // Add extra uniqueness
          position: { x: listener.position.x, y: listener.position.y } 
        };
        
        // Prevent duplicate messages by checking if this message is already visible
        setVisibleMessages(prev => {
          if (prev.some(m => m.id === latestMsg.id)) return prev;
          return [...prev.slice(-5), msgWithPosition];
        });
        
        setTimeout(() => {
          setVisibleMessages(prev => prev.filter(m => m.id !== latestMsg.id));
        }, 4000);
      }
    }
  }, [messages, listeners]);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-30">
      <AnimatePresence>
        {visibleMessages.map((msg) => (
          <motion.div
            key={msg.uniqueKey || msg.id}
            initial={{ opacity: 0, scale: 0.8, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: -10 }}
            transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            className="absolute"
            style={{ left: `calc(${msg.position.x}% + 24px)`, top: `calc(${msg.position.y}% - 20px)`, maxWidth: '200px' }}
            data-testid={`chat-bubble-${msg.id}`}
          >
            <div className="relative">
              <div className="absolute -left-2 top-3 w-0 h-0 border-t-[6px] border-t-transparent border-r-[8px] border-r-[#12101A]/90 border-b-[6px] border-b-transparent" />
              <div className="bg-[#12101A]/90 backdrop-blur-md rounded-xl px-3 py-2 border border-white/10">
                <span className="text-[#00F0FF] text-xs font-medium">{msg.user}</span>
                <p className="text-white text-sm mt-0.5">{msg.text}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default SpatialChat;
